<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix" style="text-align: left">
      如果你有以下疑问
    </div>
    <div>
      <el-collapse class="left-text-content" style="padding: 0;" v-model="activeTipAnswers">
        <el-collapse-item v-for="(item, index) in tipTexts" :key="index" :name="index">
          <span slot="title">{{item.question}}</span>
          <div v-html="item.answer"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </el-card>
</template>

<script>
  import {
    tipTextList
  } from '~/static/resumeTipText.js';  
  export default {
    components: {
    },
    data() {
      return {
        activeName: 'tip',
        tipCategory: 8,
        tipTexts: [],
        activeTipAnswers: [0]        
      };
    },
    created() {
      if (this.tipCategory) {
        this.onTipCategoryChange(this.tipCategory);
      }
    },
    methods: {
      onTipCategoryChange(val) {
        this.tipTexts = tipTextList.find(t => t.categoryId === val).children;
      },
    }
  };
</script>

<style>

</style>